/* Add to cart in the product preview of Selleasy's cart upsell.
 *
 * A card whose product has several variants has no picker of its own: its button reads "Choose"
 * and opens the preview, where the variant is picked and the add button below does the adding.
 * Single-variant cards add directly, as Selleasy builds them.
 *
 * Selleasy's preview only has a "view more" button. This adds a primary add button to it that
 * presses the matching carousel card's own button, so Selleasy's add flow runs unchanged (it tags
 * the line for its sales attribution and refreshes the cart itself). The labels come from the
 * theme's locale through the data-add-label and data-choose-label attributes on this script tag.
 *
 * It stays out of the way when it can't do the whole job: without this script the cards keep
 * Selleasy's own picker and add button (the CSS hides them only under .cart-upsell-js), a card
 * whose image doesn't open a preview keeps them too, and a preview that gets no add button turns
 * the "Choose" button off for the rest of the page view.
 */
(function () {
  var script = document.currentScript;
  var label = script && script.getAttribute('data-add-label');
  var chooseLabel = ((script && script.getAttribute('data-choose-label')) || '').trim();
  var passing = false;
  var ADD_CLASS = 'cart-upsell-add';
  var variantWait = 1500;
  var previewWait = 1500;

  if (!label) return;
  document.documentElement.classList.add('cart-upsell-js');
  var off = false;

  function isChooser(card) {
    return Array.prototype.some.call(card.querySelectorAll('select.lb-variant-picker'), function (select) {
      return select.options.length > 1;
    });
  }

  // A chooser card is ours only while its image opens a preview and we haven't given up.
  function isOurs(card) {
    return !off && isChooser(card) && !!card.querySelector('lb-card-image[lb-preview="true"]');
  }

  // Selleasy's own word on the card buttons, kept from the first one we relabel.
  var selleasyLabel = '';
  // When the fallback gave up, so a press already under way still gets swallowed.
  var offAt = 0;
  var offGrace = 600;

  // The text node Selleasy writes the button's word into.
  function labelNode(button) {
    return Array.prototype.filter.call(button.childNodes, function (node) {
      return node.nodeType === 3 && node.nodeValue.trim();
    })[0];
  }

  function readsChoose(button) {
    var text = chooseLabel && selleasyLabel.trim() !== chooseLabel && labelNode(button);
    return !!text && text.nodeValue.trim() === chooseLabel;
  }

  // A press on our card opens the preview. Selleasy renders its cards without keys and reuses a
  // card element for another product when it reshuffles its offers, which leaves our word on the
  // button after the card stopped being ours (a single-variant product, or a chooser down to one
  // variant). A button that still reads "Choose" gets Selleasy's word back and adds nothing.
  // Right after we give up, a press on a card that still has its picker is swallowed too: it may
  // have started on "Choose" and ended on the restored "Add".
  function pressed(target) {
    var button = target.closest && target.closest('.lb-button');
    var card = button && button.closest('.main-cart_upsell-inline lb-upsell-flat-card');
    if (!card) return null;
    if (isOurs(card)) return { card: card, open: true };
    if (readsChoose(button)) return { card: card, open: false };
    if (off && Date.now() - offAt < offGrace && isChooser(card)) return { card: card, open: false };
    return null;
  }

  // Remembers that the preview opened from "Choose" and the shopper still has to pick.
  var fromChoose = false;
  // Whether an add button mounted since the last "Choose"; the fallback timer reads it.
  var mountedSinceOpen = false;

  function openPreview(card) {
    var image = card.querySelector('lb-card-image img') || card.querySelector('lb-card-image');
    if (!image) return;
    fromChoose = true;
    mountedSinceOpen = false;
    image.click();
    // No add button in the preview: Selleasy's markup has changed. Hand the cards back.
    setTimeout(function () {
      fromChoose = false;
      if (off || mountedSinceOpen) return;
      off = true;
      offAt = Date.now();
      sync();
    }, previewWait);
  }

  function intercept(event) {
    var hit = !passing && pressed(event.target);
    if (!hit) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (hit.open) openPreview(hit.card);
    else labelChoosers();
  }

  // Capture on window, ahead of Selleasy's own handlers on the button.
  window.addEventListener('click', intercept, true);
  window.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') intercept(event);
  }, true);

  // Selleasy writes "Add" into the button; a chooser card says "Choose". The text node is
  // reused so Selleasy's own updates still land on it, and sync() sets it again after one. A card
  // we don't handle (no preview to open, or we gave up) gets Selleasy's own word back and keeps
  // its picker.
  function labelChoosers() {
    var cards = document.querySelectorAll('.main-cart_upsell-inline lb-upsell-flat-card');
    Array.prototype.forEach.call(cards, function (card) {
      var ours = isOurs(card);
      card.classList.toggle('is-keeping-picker', isChooser(card) && !ours);
      var button = card.querySelector('.lb-button');
      var text = button && labelNode(button);
      if (!text) return;
      var current = text.nodeValue.trim();
      if (ours && chooseLabel) {
        if (current !== chooseLabel) {
          selleasyLabel = text.nodeValue;
          text.nodeValue = chooseLabel;
        }
      } else if (selleasyLabel && current === chooseLabel) {
        text.nodeValue = selleasyLabel;
      }
    });
  }

  function cardFor(info) {
    var handle = info.getAttribute('lb-product-handle');
    if (!handle) return null;
    var cards = document.querySelectorAll('.main-cart_upsell-inline lb-upsell-flat-card');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('lb-product-handle') === handle) return cards[i];
    }
    return null;
  }

  function cardButton(card) {
    var button = card && card.querySelector('.lb-button');
    if (!button || button.getAttribute('aria-disabled') === 'true' || button.hasAttribute('disabled')) return null;
    return button;
  }

  // Selleasy sizes a picker by appending a copy of its select (visibility hidden, one option) for
  // 100ms, so a picker can briefly appear several times. Only a select that is visible counts.
  function shown(select) {
    return select.offsetHeight > 0 && getComputedStyle(select).visibility !== 'hidden';
  }

  function pickers(root) {
    return Array.prototype.filter.call(root.querySelectorAll('lb-variant-picker select.lb-variant-picker'), shown);
  }

  // The variant the modal has chosen: '' when the product has nothing to choose, a variant id
  // when the modal's one picker is set to a variant the card also offers, and null when that
  // can't be told (several pickers, or an id the card doesn't know). The add button never
  // guesses: null means no button.
  function chosenVariant(info, card) {
    var own = pickers(info);
    if (!own.length) return isChooser(card) ? null : '';
    if (own.length > 1) return null;
    var id = own[0].value;
    var offered = Array.prototype.some.call(card.querySelectorAll('select.lb-variant-picker option'), function (o) {
      return o.value === id;
    });
    return id && offered ? id : null;
  }

  function waitFor(test, done) {
    var start = Date.now();
    (function poll() {
      if (test()) return done(true);
      if (Date.now() - start > variantWait) return done(false);
      setTimeout(poll, 50);
    })();
  }

  function choose(info, card, done) {
    var id = chosenVariant(info, card);
    if (id === null) return done(false);
    if (id === '' || card.getAttribute('lb-variant-id') === id) return done(true);
    var cardSelect = Array.prototype.filter.call(card.querySelectorAll('select.lb-variant-picker'), function (s) {
      return Array.prototype.some.call(s.options, function (o) { return o.value === id; });
    })[0];
    if (!cardSelect) return done(false);
    cardSelect.value = id;
    cardSelect.dispatchEvent(new Event('input', { bubbles: true }));
    cardSelect.dispatchEvent(new Event('change', { bubbles: true }));
    waitFor(function () { return card.getAttribute('lb-variant-id') === id; }, done);
  }

  var closed = [];

  function add(info, trigger) {
    var card = cardFor(info);
    if (!card || trigger.disabled) return;
    trigger.disabled = true;
    choose(info, card, function (ok) {
      var button = cardButton(card);
      if (ok && button) {
        passing = true;
        try { button.click(); } finally { passing = false; }
        var close = document.querySelector('#lb-upsell-dialog .lb-popup-cont-action-close');
        if (close) close.click();
        trigger.disabled = false;
        return;
      }
      // Fail closed: no add button for this modal rather than one that does nothing.
      closed.push(info);
      trigger.remove();
    });
  }

  // Two buttons side by side, or stacked when a label would not fit its half.
  function fit(host) {
    host.classList.remove('is-stacked');
    var buttons = host.querySelectorAll('.' + ADD_CLASS + ', .lb-button');
    var clipped = Array.prototype.some.call(buttons, function (button) {
      var text = button.querySelector('span');
      return text ? text.offsetWidth + 32 > button.clientWidth : button.scrollWidth > button.clientWidth;
    });
    if (clipped && host.querySelector('.' + ADD_CLASS)) host.classList.add('is-stacked');
  }

  var hosts = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { fit(entry.target); });
  }) : null;

  function mount(info) {
    var dialog = info.closest('#lb-upsell-dialog');
    var existing = dialog.querySelector('.' + ADD_CLASS);
    var card = cardFor(info);
    if (closed.indexOf(info) !== -1) return;
    if (!card || !cardButton(card) || chosenVariant(info, card) === null) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    var host = dialog.querySelector('.lb-popup-cont-footer') || info.querySelector('.lb-product-info-details-button');
    if (!host) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = ADD_CLASS;
    var text = document.createElement('span');
    text.textContent = label;
    button.appendChild(text);
    button.addEventListener('click', function () { add(info, button); });
    host.insertBefore(button, host.firstChild);
    mountedSinceOpen = true;
    fit(host);
    if (hosts) hosts.observe(host);
    revealPicker(info, host);
  }

  // On a phone the footer sits over the bottom of the scrolled body, and a shopper who came from
  // "Choose" would see the add button before the picker. Bring the picker clear of the footer once.
  function revealPicker(info, host) {
    if (!fromChoose) return;
    fromChoose = false;
    if (!host.classList.contains('lb-popup-cont-footer')) return;
    var picker = pickers(info)[0];
    if (picker) picker.scrollIntoView({ block: 'center' });
  }

  // The description ends in an ellipsis above the buttons. On a phone the body scrolls and the
  // CSS default of 5 lines stands; the only job there is to keep the last line clear of the footer
  // bar when it covers the body. On wider screens the lines that fit the details column above the
  // button row are measured, so the clamp is as tall as the popup allows and never taller.
  function fitDescription(info) {
    var desc = info.querySelector('.lb-product-info-description');
    var body = info.closest('.lb-popup-cont-body');
    var column = info.querySelector('.lb-product-info-details-cont');
    if (!desc || !body || !column) return;
    var footer = body.parentNode.querySelector('.lb-popup-cont-footer');
    var overlap = footer ? Math.max(0, Math.ceil(body.getBoundingClientRect().bottom - footer.getBoundingClientRect().top)) : 0;
    body.style.setProperty('--cu-overlap', overlap + 'px');
    if (footer || info.querySelector('.lb-product-info-full')) {
      desc.style.removeProperty('--cu-lines');
      return;
    }
    var line = parseFloat(getComputedStyle(desc).lineHeight);
    var cont = info.closest('.lb-popup-cont');
    if (!line || !cont) return;
    var bodyStyle = getComputedStyle(body), infoStyle = getComputedStyle(info.querySelector('.lb-product-info') || info);
    var chrome = cont.offsetHeight - body.clientHeight;      // header bar above the body
    var cap = parseFloat(getComputedStyle(cont).maxHeight);  // Selleasy caps the popup, in % of the dialog
    if (/%$/.test(getComputedStyle(cont).maxHeight)) cap = cont.parentElement.clientHeight * cap / 100;
    var pad = parseFloat(bodyStyle.paddingTop) + parseFloat(bodyStyle.paddingBottom) +
      parseFloat(infoStyle.paddingTop) + parseFloat(infoStyle.paddingBottom);
    var others = column.offsetHeight - desc.offsetHeight;    // title, price, picker, buttons, gaps
    var image = info.querySelector('.lb-product-info-img-cont');
    // Fill the column up to the image's height or the popup's cap, whichever is lower, and never
    // fewer than 5 lines unless the popup is shorter than that, where the body scrolls instead.
    var room = Math.min(cap - chrome - pad, Math.max(image ? image.offsetHeight : 0, others + 5 * line));
    var lines = Math.max(3, Math.min(8, Math.floor((room - others) / line)));
    desc.style.setProperty('--cu-lines', String(lines));
  }

  var fitted = typeof ResizeObserver === 'function' ? new ResizeObserver(function () {
    var dialog = document.getElementById('lb-upsell-dialog');
    var info = dialog && dialog.querySelector('lb-product-info[lb-modal="preview"]');
    if (info) fitDescription(info);
  }) : null;
  var watched = null;

  function sync() {
    labelChoosers();
    var dialog = document.getElementById('lb-upsell-dialog');
    var info = dialog && dialog.querySelector('lb-product-info[lb-modal="preview"]');
    if (info) {
      mount(info);
      fitDescription(info);
      var cont = info.closest('.lb-popup-cont');
      if (fitted && cont && cont !== watched) {
        if (watched) fitted.disconnect();
        watched = cont;
        fitted.observe(cont);
        fitted.observe(info);
      }
    }
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  sync();
})();
